import { service } from '../../api/axios';
import { TNotification } from './getNotifications';

export const patchNotification = async (
  notificationID: string,
  updates: Partial<TNotification>
) => {
  const response = await service.patch<TNotification>(
    `/notifications/${notificationID}`,
    updates
  );
  return response.data;
};
